/* eslint-disable import/prefer-default-export */
import axios from '../axios';

// ---------------------------------------------------------------------------
// RH — Requisitos por cargo (handoff 0065 §8).
//
// Dirige o checklist de admissão: um requisito { requirement_type: 'DOCUMENT',
// document_type_id } faz o documento (ex.: CNH) entrar no checklist dos
// candidatos cujo cargo efetivo do pré-cadastro é este. Os demais
// requirement_type (COURSE, TECHNICAL_EXPERIENCE, SKILL, OTHER) são fundação —
// ainda não afetam o checklist. Permissões: hr:job_position_requirement:*.
// ---------------------------------------------------------------------------

export async function listRequirements(jobPositionId) {
   const response = await axios.get(
      `/hr/job-positions/${jobPositionId}/requirements`,
   );
   return response?.data?.data?.requirements ?? [];
}

// payload: { requirement_type, document_type_id?, label?, is_mandatory?, notes? }
export async function createRequirement(jobPositionId, payload = {}) {
   const body = { requirement_type: payload.requirement_type };
   if (payload.document_type_id) {
      body.document_type_id = payload.document_type_id;
   }
   if (payload.label) body.label = payload.label;
   if ('is_mandatory' in payload) body.is_mandatory = payload.is_mandatory;
   if (payload.notes) body.notes = payload.notes;

   const response = await axios.post(
      `/hr/job-positions/${jobPositionId}/requirements`,
      body,
   );
   return {
      requirement: response?.data?.data?.requirement ?? null,
      message: response?.data?.message ?? 'Requisito criado.',
   };
}

// Backend responde 204 sem body.
export async function deleteRequirement(jobPositionId, requirementId) {
   await axios.delete(
      `/hr/job-positions/${jobPositionId}/requirements/${requirementId}`,
   );
}
